import { Store, Module, ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import SupplierOfferItem from "../../entities/booking/supplierOfferItem";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface SupplierOfferItemState extends ListState<SupplierOfferItem> {
  editSupplierOfferItem: SupplierOfferItem;
  permissions: Array<string>;
  treePermissions: Array<TreePermission>;
}

interface TreePermission {
  title: string;
  checked: boolean;
  expand: boolean;
  children: Array<TreePermission>;
}
class SupplierOfferItemModule extends ListModule<
  SupplierOfferItemState,
  any,
  SupplierOfferItem
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<SupplierOfferItem>(),
    loading: false,
    editSupplierOfferItem: new SupplierOfferItem(),
    permissions: new Array<string>(),
    treePermissions: new Array<TreePermission>(),
  };
  actions = {
    async getAll(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/SupplierOfferItem/GetAll",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      let page = reponse.data.result as PageResult<SupplierOfferItem>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAllFlat(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/SupplierOfferItem/GetAllFlat",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      let page = reponse.data.result as any;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateIsOnSale(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      console.log(payload, "payload");
      return await Ajax.post(
        "/api/services/app/SupplierOfferItem/ChangeIsOnSale",
        payload.data
      );
    },
    async create(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      await Ajax.post(
        "/api/services/app/SupplierOfferItem/Create",
        payload.data
      );
    },
    async update(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      await Ajax.put(
        "/api/services/app/SupplierOfferItem/Update",
        payload.data
      );
    },
    async exportOffers() {
      return  Ajax.get("/api/services/app/SupplierOfferItem/ExportOffers");
    },
    async delete(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      await Ajax.delete(
        "/api/services/app/SupplierOfferItem/Delete?Id=" + payload.data.id
      );
    },
    async get(
      context: ActionContext<SupplierOfferItemState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/SupplierOfferItem/Get?Id=" + payload.id
      );
      return reponse.data.result as SupplierOfferItem;
    },
  };
  mutations = {
    setCurrentPage(state: SupplierOfferItemState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: SupplierOfferItemState, pagesize: number) {
      state.pageSize = pagesize;
    },
    setList(state: SupplierOfferItemState) {
      console.log("执行setList");
      state.list = [];
    },
    edit(state: SupplierOfferItemState, supplierOfferItem: SupplierOfferItem) {
      state.editSupplierOfferItem = supplierOfferItem;
    },
  };
}
const supplierOfferItemModule = new SupplierOfferItemModule();
export default supplierOfferItemModule;
